import { Assert } from '@team/assert';
import { ImageSources } from '../../types';
import { MIN_PIXEL_RATIO } from '../../const';
import { createSrcByPixelRatio } from '../create-src-by-pixel-ratio';

export const createSrcSet = ({ base, x2, x3, x4 }: ImageSources) =>
  [base, x2, x3, x4]
    .filter(Assert.isString)
    .map((path, offset) =>
      createSrcByPixelRatio(path, MIN_PIXEL_RATIO + offset)
    )
    .join(', ');
